import { useContext, useEffect, useRef, useState } from 'react'

import { NotificationContext, NotificationToast } from '@hm-group/bads-react'

import { NotificationToastPayload, SnackBarService } from '@/services/SnackBarService'

type ToastRequest = { toast: NotificationToastPayload | null }

export default function AppNotificationToast(): React.JSX.Element {
  const notification = useContext(NotificationContext)
  const notificationRef = useRef(notification)
  const [request, setRequest] = useState<ToastRequest | null>(null)
  notificationRef.current = notification

  useEffect(() => {
    const subscription = SnackBarService.getToast().subscribe((toast) => {
      setRequest({ toast })
    })

    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    if (!request) return

    const currentNotification = notificationRef.current
    if (!currentNotification) return

    currentNotification.toasts.forEach(({ id }) => currentNotification.removeToast(id))
    if (request.toast) currentNotification.addToast(request.toast)
  }, [request])

  return <NotificationToast yOffset="3.5rem" />
}
